var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./stage.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3f0b4b1a\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./stage.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./pipelines/components/stage.vue
// module id = ./pipelines/components/stage.vue
// module chunks = commit_pipelines pipelines vue_merge_request_widget